import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=8bf62004"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"
import style0 from "./Counter.vue?vue&type=style&index=0&id=8bf62004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports